import styled from 'styled-components';
import { MarginProps, space } from 'styled-system';

import { colors } from 'theme';

import { getBorder, getStyle } from './infoBoxStyleHelpers';

export const InfoBox = styled.div<{
  $boxStyle?: 'default' | 'modal' | 'form';
  $small?: boolean;
  $type?: 'info' | 'warning' | 'danger';
  mt?: MarginProps['mt'];
  mb?: MarginProps['mb'];
}>`
  border-radius: 4px;
  background-color: ${(props) =>
    props.$small ? colors.inputGrey : colors.calloutGrey};
  ${(props) =>
    props.$small
      ? `
    padding: 4px 12px;
  `
      : getStyle(props.$boxStyle)};
  ${(props) => props.$type && getBorder(props.$type)};
  ${space};
  a {
    display: inline;
    color: ${colors.brandBlue};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
